import React from 'react';
import ReservationSegmentCheckInErrors from './ReservationSegmentCheckInErrors';
import ReservationSegmentCheckInRoomDetails from './ReservationSegmentCheckInRoomDetails';
import ReservationSegmentCheckInPayments from './ReservationSegmentCheckInPayments';

export default class ReservationSegmentCheckInGeneral extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    
    return(
      <div className={this.props.activeTab === 'general' ? 'active tab-pane' : 'tab-pane'}>
        {this.renderErrors()}
        <ReservationSegmentCheckInRoomDetails {...this.props} />
        <ReservationSegmentCheckInPayments {...this.props} />
      </div>
    );
  };

  renderErrors() {
    var errors = ReservationSegmentCheckInErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }
};